import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { RegistrationFieldType } from "@/model/Enums";
import { FieldDependency, IFieldDependency } from "@/model/FieldDependency";

export interface IExtraRegistrationField {
    key: string;
    fieldType: RegistrationFieldType;
    label: string;
    isMandatory: boolean;
    showIf: IFieldDependency;
    isAllPathways: boolean;
    pathwayIds: Array<string>;
}

export class ExtraRegistrationField implements IExtraRegistrationField {

    constructor(data?: IExtraRegistrationField) {
        if (data) this.update(data);
    }

    update(data: IExtraRegistrationField): ExtraRegistrationField {
        mapData(data, {
            root: () => this,
            showIf: (data: IFieldDependency) => this.showIf.update(data),
        });
        if (this.isAllPathways == null) this.isAllPathways = true; // old class did not have this property
        if (this.pathwayIds == null) this.pathwayIds = []; // old class did not have this property
        return this;
    }

    key: string = "";
    fieldType: RegistrationFieldType = RegistrationFieldType.None;
    label: string = "";
    isMandatory: boolean = false;
    showIf: FieldDependency = new FieldDependency();
    isAllPathways: boolean = true;
    pathwayIds: Array<string> = [];

    static createNew(): ExtraRegistrationField {
        return new ExtraRegistrationField({
            key: Utils.createKey(6),
            fieldType: RegistrationFieldType.None,
            label: "",
            isMandatory: false,
            showIf: { key: "", value: "" },
            isAllPathways: true,
            pathwayIds: []
        });
    }
}
